import { ModelFactory } from '@leverege/ui-plugin';
import DetailListModel from "./shared/DetailListModel.js";
import ExportFields from "../export/ExportFields.js";
import ExportModel from "../export/shared/ExportModel.js"; // eslint-disable-next-line import/prefer-default-export
export function createDetailExportModel(value, objectType) {
  if (!objectType) {
    return null;
  }
  if (Array.isArray(objectType)) {
    return objectType.map(type => getExportModel(value, type)).reduce((prev, curr) => {
      if (Object.keys(prev).length === 0) {
        return {
          ...curr
        };
      }
      return {
        ...prev,
        fields: [...prev.fields, ...curr.fields.filter(field => {
          const existingField = prev.fields.find(f => f.attrName === field.attrName);
          if (existingField) {
            return false;
          }
          return true;
        })]
      };
    }, {});
  }
  return getExportModel(value, objectType);
}
function getExportModel(value, objectType) {
  const DetailModel = ModelFactory.get(value);
  const typeValue = DetailModel.getType(value, objectType);
  const TypeModel = ModelFactory.get(typeValue);
  const detailValue = TypeModel.getDetails(typeValue);
  const details = DetailListModel.getDetails(detailValue);
  const headerVisible = DetailListModel.getHeaderVisible(detailValue);
  const headerNameAttr = DetailListModel.getHeaderNameAttribute(detailValue);
  const fieldCreators = [];

  // Not sure if we want to enable this since it might be confusing to a user?
  if (headerVisible && headerNameAttr != null) {
    const headerFieldCreator = ExportFields.getExportField(headerNameAttr, objectType);
    if (headerFieldCreator) {
      fieldCreators.push({
        fieldCreator: headerFieldCreator
      });
    }
  }
  if (details && details.length > 0) {
    details.forEach(detail => {
      const fieldCreator = ExportFields.getExportField(detail?.attrName, objectType);
      if (fieldCreator) {
        fieldCreators.push({
          fieldCreator,
          formatter: detail.formatter
        });
      }
    });
  }
  if (fieldCreators.length > 0) {
    return ExportModel.create({
      fields: fieldCreators.map(creator => creator.fieldCreator.create({
        formatter: creator.formatter
      }))
    });
  }
  return ExportModel.create({
    fields: ExportFields.getExportFieldsFor(objectType).map(creator => creator.create())
  });
}